import { render, staticRenderFns } from "./OfferLinks.vue?vue&type=template&id=67a9d32a&"
import script from "./OfferLinks.vue?vue&type=script&lang=ts&"
export * from "./OfferLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports